import { ComponentProps } from "react";
import CardGroupedListItem from "@particles/card/components/CardGroupedList/CardGroupedListItem";

type CardGroupedListProps = {
  /** The list of articles to display under the title */
  groupedArticles: ComponentProps<typeof CardGroupedListItem>[];
};

/**
 * Renders a list of grouped article cards.
 */
const CardGroupedList = ({
  groupedArticles,
}: CardGroupedListProps): React.ReactElement | null => {
  return (
    <ul
      data-testid="card-grouped-list-component"
      className="ml-4 mt-2 list-outside list-[square] text-left font-lct font-bold"
    >
      {groupedArticles.map((article) => (
        <CardGroupedListItem {...article} key={article.id} />
      ))}
    </ul>
  );
};

export default CardGroupedList;
